import {
  MAX_CLIENT_SIDE_FORM_FIELDS,
  type FormToolFormState,
} from './formFieldDefaults';

export function validateFormToolForm(form: FormToolFormState): string | null {
  if (!form.name.trim()) {
    return 'Name is required.';
  }

  if (form.description.trim().length < 10) {
    return 'Description must be at least 10 characters.';
  }

  if (!form.formTitle.trim()) {
    return 'Form title is required.';
  }

  if (form.fields.length === 0) {
    return 'Add at least one field.';
  }

  if (form.fields.length > MAX_CLIENT_SIDE_FORM_FIELDS) {
    return `Maximum ${MAX_CLIENT_SIDE_FORM_FIELDS} fields allowed.`;
  }

  const names = new Set<string>();

  for (const field of form.fields) {
    if (!field.label.trim()) {
      return 'Every field needs a label.';
    }

    if (!field.name.trim()) {
      return 'Every field needs a name.';
    }

    if (names.has(field.name)) {
      return `Duplicate field name "${field.name}".`;
    }

    names.add(field.name);

    if (
      field.type === 'select' &&
      (!field.options || field.options.length < 2)
    ) {
      return `Select field "${field.label}" needs at least two options.`;
    }
  }

  return null;
}
